import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-dashboard',
  templateUrl: './help-dashboard.component.html',
  styleUrls: ['./help-dashboard.component.scss'],
  standalone: true,
})
export class HelpDashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
